import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetScreenConfigByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigByIdController.php
* @route '/api/screen-config/{screenConfig}'
*/
const GetScreenConfigByIdController = (args: { screenConfig: string | number | { id: string | number } } | [screenConfig: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenConfigByIdController.url(args, options),
    method: 'get',
})

GetScreenConfigByIdController.definition = {
    methods: ["get","head"],
    url: '/api/screen-config/{screenConfig}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetScreenConfigByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigByIdController.php
* @route '/api/screen-config/{screenConfig}'
*/
GetScreenConfigByIdController.url = (args: { screenConfig: string | number | { id: string | number } } | [screenConfig: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { screenConfig: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { screenConfig: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            screenConfig: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        screenConfig: typeof args.screenConfig === 'object'
        ? args.screenConfig.id
        : args.screenConfig,
    }

    return GetScreenConfigByIdController.definition.url
            .replace('{screenConfig}', parsedArgs.screenConfig.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetScreenConfigByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigByIdController.php
* @route '/api/screen-config/{screenConfig}'
*/
GetScreenConfigByIdController.get = (args: { screenConfig: string | number | { id: string | number } } | [screenConfig: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenConfigByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetScreenConfigByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigByIdController.php
* @route '/api/screen-config/{screenConfig}'
*/
GetScreenConfigByIdController.head = (args: { screenConfig: string | number | { id: string | number } } | [screenConfig: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetScreenConfigByIdController.url(args, options),
    method: 'head',
})

export default GetScreenConfigByIdController